import React, { useEffect } from "react";
import Navbar from "../components/homepage/Navbar";
 
import ShippingPolicy from "../components/shippingPolicy/ShippingPolicy";
import ShippingPolicyHero from "../components/shippingPolicy/ShippingPolicyHero";
import { Header, Footer } from "../shared";

const ShippingPolicyPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <div className="bg_darkblue">
        <Header />
      </div>
      <ShippingPolicyHero />
      <ShippingPolicy />
      <Footer />
    </div>
  );
};

export default ShippingPolicyPage;
